// Single serialization language for list query params → API `searchParams`
// (Record<string, string>, as consumed by `fetchApi`'s `searchParams` option).
// Collapses the 3 previous ad-hoc languages seen across `*.queries.ts`
// (Record→searchParams, manual `new URLSearchParams(...)`, query-string
// template literals) into one deterministic helper.
export type ListSearchParamsInput = Record<
  string,
  string | number | boolean | null | undefined
>;

export function toListSearchParams(
  params: ListSearchParamsInput,
): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    result[key] = String(value);
  }
  return result;
}
